














import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import DocumentManageNumberInputDialog from "../dialogs/DocumentManageNumberInputDialog.vue";

@Component({
  components: {
    DocumentManageNumberInputDialog,
  },
})
export default class DocumentManageNumberInput extends Mixins(ModelEditableMixin) {
  $refs!: {
    manageNumberInputDialog: DocumentManageNumberInputDialog,
  };

  get manageNumberText(): string {
    return this.editingSource;
  }

  set manageNumberText(value: string) {
    this.input(value);
  }

  showManageNumberInputDialog(): void {
    this.$refs.manageNumberInputDialog.show(this.manageNumberText)
    .then(result => {
      if (result == null) { return; }
      this.manageNumberText = result;
    });
  }

  clear(): void {
    this.manageNumberText = null;
  }
}
